import { render, staticRenderFns } from "./AxDev.vue?vue&type=template&id=485a4ca2&scoped=true"
import script from "./AxDev.vue?vue&type=script&lang=ts"
export * from "./AxDev.vue?vue&type=script&lang=ts"
import style0 from "./AxDev.vue?vue&type=style&index=0&id=485a4ca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485a4ca2",
  null
  
)

export default component.exports